import { Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { BspkTxt } from '../txt';

export type InlineAlertVariant = 'informational' | 'success' | 'warning' | 'error';

const icons: Record<InlineAlertVariant, string> = {
  informational: 'info',
  success: 'check_circle',
  warning: 'warning',
  error: 'error',
};

@Component({
  selector: 'bspk-inline-alert',
  imports: [BspkTxt, MatIcon],
  templateUrl: './inline-alert.component.html',
  styleUrl: './inline-alert.component.scss',
  host: {
    '[attr.data-variant]': 'variant()',
  },
})
export class BspkInlineAlert {
  readonly variant = input<InlineAlertVariant>('informational');
  readonly icon = computed(() => icons[this.variant()]);
}
